module.exports = __webpack_public_path__ + "img/industry_icon.08a2a8c9.svg";